interface FetchErrorParams {
  statusCode?: number;
  response: Response;
  headers?: Headers;
  body?: any;
}

export default class FetchError extends Error {
  type: string;
  statusCode?: number;
  data: {
    response: Response;
    headers?: Headers;
    body?: any;
  };

  constructor({ statusCode, response, headers, body }: FetchErrorParams) {
    super(`${response?.statusText} ${response?.url}`);

    this.type = 'FetchError';
    this.name = this.constructor.name;
    this.data = { response, headers, body };
    this.statusCode = statusCode;
  }
}
